// extracted by mini-css-extract-plugin
export default {"wrapper":"ArtForAirTiff_wrapper__+MDZK","quotes":"ArtForAirTiff_quotes__xuMAL","text":"ArtForAirTiff_text__LVFyW","articleWrapper":"ArtForAirTiff_articleWrapper__cVBhk"};